<template>
  <div class="number-input-container">
    <label v-if="label" class="number-input-label">{{ label }}</label>
    <div class="number-input" :class="{ 'number-input--focused': isFocused, 'number-input--disabled': disabled }">
      <input
        class="number-input-field"
        type="text"
        inputmode="numeric"
        :placeholder="placeholder"
        :value="modelValue"
        :disabled="disabled"
        autocomplete="nope"
        data-lpignore="true"
        data-form-type="other"
        @input="handleInput"
        @focus="isFocused = true"
        @blur="isFocused = false"
        @keydown="handleKeydown"
        ref="input"
      />
      <span v-if="suffix" class="number-suffix">{{ suffix }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberInput',
  props: {
    modelValue: { type: String, default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '0' },
    suffix: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  data() {
    return { isFocused: false }
  },
  methods: {
    handleKeydown(event) {
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Home', 'End']
      const isDigit = /^\d$/.test(event.key)
      const hasModifier = event.ctrlKey || event.metaKey || event.altKey

      if (!isDigit && !allowedKeys.includes(event.key) && !hasModifier) {
        event.preventDefault()
      }
    },
    handleInput(event) {
      const value = event.target.value.replace(/\D/g, '')
      this.$emit('update:modelValue', value)
    }
  }
}
</script>

<style scoped>
.number-input-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.number-input-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}

.number-input {
  display: flex;
  align-items: center;
  min-height: 45px;
  background: #FFF;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  transition: all 0.15s ease;
  overflow: hidden;
}

.number-input:hover:not(.number-input--disabled) {
  border-color: #9ca3af;
}

.number-input--focused {
  border-color: var(--color-primary, #6a16f0);
  box-shadow: 0 0 0 3px rgba(106, 22, 240, 0.1);
}

.number-input--disabled {
  background: #fafafa;
  cursor: not-allowed;
}

.number-suffix {
  padding-right: 12px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #9ca3af;
  flex-shrink: 0;
  user-select: none;
  white-space: nowrap;
}

.number-input-field {
  width: 100%;
  height: 100%;
  padding: 0 12px;
  font-size: 1rem;
  font-weight: 400;
  color: #374151;
  background: transparent;
  border: none;
  outline: none;
  box-sizing: border-box;
}

.number-input-field::placeholder {
  color: #d1d5db;
}

.number-input-field:disabled {
  cursor: not-allowed;
}
</style>
